import { DropDownMenuComponent } from "./component";
export const DropDownMenu = DropDownMenuComponent;
